import React, { ComponentType } from 'react';
import { isAuthenticated } from '../data-layer/authentication/service';
import { withInvariant } from '../utils/withInvariant';
import { Redirect } from './Redirect';

export function withAuthProtection<TProps extends {}>(
    BaseComponent: ComponentType<TProps>,
): ComponentType<TProps> {
    return withInvariant(
        (props: TProps) => {
            if (isAuthenticated()) {
                // @ts-ignore
                return <BaseComponent {...props} />;
            }

            return (
                <Redirect
                    url={`${process.env.REACT_APP_PASSPORT_URL}/auth?retpath=${window.location.href}`}
                />
            );
        },
        () => null,
    );
}
